var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70739 4.27501C2.14446 3.55111 4.52103 0.95598 6.21469 1.02427C6.73995 1.09107 7.2242 1.34291 7.58054 1.73454C8.88971 3.10959 10.023 4.64193 10.9542 6.29645C11.282 7.8945 9.38346 8.80962 9.95711 10.394C10.6325 12.1369 11.664 13.7197 12.9857 15.0414C14.3074 16.3632 15.8903 17.3947 17.6332 18.0701C19.2449 18.6438 20.16 16.7043 21.7308 17.0731C23.3793 18.0136 24.9106 19.146 26.2928 20.4467C26.6803 20.8044 26.9274 21.2888 26.9894 21.8125C26.9894 23.6018 24.2577 26.0194 23.7523 26.3199C22.482 27.2214 20.8294 27.2077 18.8079 26.3199C13.1669 23.9706 4.15224 15.1334 1.76199 9.27391C0.833211 7.21148 0.764948 5.5316 1.70739 4.27501Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlack);
export default __webpack_public_path__ + "static/media/phone-black.ed29ce484ea5777cdd84176bd5b0d2cb.svg";
export { ForwardRef as ReactComponent };